import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ReloadSvg } from "../../components/Assets";
import OutlineSubBtn from "../../components/buttons/OutlineSubBtn";
import SolidBlueBtn from "../../components/buttons/SolidBlueBtn";
import BlueTag from "../../components/tags/BlueTag";
import LightBlueTag from "../../components/tags/LightBlueTag";
import { BTN_APPLY, BTN_CANCEL } from "../../text-data";
import { key2Kr, reviewStatusKeys, timeKeys } from "./ReviewStatusKeys";

const FilterBtns = function ({ lsKeys, onChange, name, isReset }) {
  const [activeIndex, setActiveIndex] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const onClick = (index) => {
    setActiveIndex(index);
    if (onChange) {
      onChange(lsKeys[index]);
    }
  };

  useEffect(()=> {
    if(isReset) {
      onClick(0)
    }
  }, [isReset])

  useEffect(() => {
    const activeKey = lsKeys.findIndex((x) => x === searchParams.get([name]));
    if (activeKey !== -1) {
      setActiveIndex(activeKey);
    } else {
      setActiveIndex(0); // All
    }
  }, []);

  return lsKeys.map((x, index) => {
    const kr = key2Kr(x);
    if (index === activeIndex) {
      return <BlueTag key={index}>{kr}</BlueTag>;
    }

    return (
      <LightBlueTag key={index} onClick={() => onClick(index)}>
        {kr}
      </LightBlueTag>
    );
  });
};

const ReviewFilterSetting = function ({ closeModal, onSubmitSearch }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isReset, setIsReset] = useState(false);

  const refTimeKey = useRef(searchParams.get("time"));
  const refReviewStatus = useRef(
    searchParams.get("search_comment_reg_status_code")
  );
  const onSubmit = () => {
    setSearchParams({
      ...searchParams,
      time: refTimeKey.current,
      search_comment_reg_status_code:
        parseFloat(refReviewStatus.current) >= 0 ? refReviewStatus.current : "",
    });
    onSubmitSearch(refTimeKey.current, refReviewStatus.current);
    closeModal();
  };

  const onReset = () => {
    setIsReset(true);
  };

  const onCancel = () => {
    closeModal();
  };
  return (
    <div className="flex flex-col gap-6 px-5 pt-6 pb-4">
      <div className="flex justify-between items-center">
        <div className="text-lg font-bold">검색 조건</div>
        <span className="flex items-center" onClick={onReset}>
          <img src={ReloadSvg} alt="Reload"></img>
          <span className="text-sm text-appblue">초기화</span>
        </span>
      </div>
      <div>
        <div className="mb-3 font-bold">리뷰 등록일</div>
        <div className="flex gap-2 flex-wrap">
          <FilterBtns
            isReset={isReset}
            lsKeys={timeKeys}
            onChange={(x) => {
              refTimeKey.current = x;
            }}
            name="time"
          />
        </div>
      </div>

      <div>
        <div className="mb-3 font-bold">댓글 상태</div>
        <div className="flex gap-2 flex-wrap">
          <FilterBtns
            isReset={isReset}
            lsKeys={reviewStatusKeys}
            onChange={(x) => {
              refReviewStatus.current = x;
            }}
            name="search_comment_reg_status_code"
          />
        </div>
      </div>

      <div className="popup-btns">
        <OutlineSubBtn className="py-4" onClick={onCancel}>
          {BTN_CANCEL}
        </OutlineSubBtn>
        <SolidBlueBtn onClick={onSubmit}>{BTN_APPLY}</SolidBlueBtn>
      </div>
    </div>
  );
};
export default ReviewFilterSetting;
